<template>
    <div id="app" :class="[ isDarkTheme ? 'dark' : '' ]">
        <div class="main-content container">
            <Navbar @theme-change="toggleTheme"/>

            <div class="margin-bottom-double" :class="[isDarkTheme ? 'card-dark' : 'body-card-border-primary p-1']">
                <div class="row">
                    <div class="col-sm-4 pull-center">
                        <span>Sincronización automática</span>
                        <br />
                        Los datos se actualizan cada 5 minutos 🔃
                    </div>
                    <div class="col-sm-4 pull-center p-0">
                        <span>Tasas, índices, cotizaciones y variación</span>
                        <br />
                        La variación se calcula con la apertura del mercado 📊
                    </div>
                    <div class="col-sm-4 pull-center">
                        <span>Soporte ágil y personalizado</span>
                        <br />
                        Si encontrás algún bug,
                        <a href="/BugReport">reportalo</a> 🐞
                    </div>
                </div>
            </div>
            
            <router-view :class="[isDarkTheme ? 'card-dark' : '']"/>

            <!-- Footer section -->
            <div class="main-content container">
                <Footer class="footer"/>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar/Navbar.vue";
import Footer from '@/components/Footers/Footer.vue'
import "@/assets/style.css";

export default {
    name: 'App',
    components: {
        Navbar,
        Footer
    },

    data() {
        return {
            isDarkTheme: false,
        };
    },

    mounted() {
        this.isDarkTheme = localStorage.getItem('theme') === 'dark';
    },

    created() {
        
    },

    methods: {
        toggleTheme(isDark) {
            this.isDarkTheme = isDark;
        }
    },

    computed: {},
};
</script>